<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getRule } from '@/services/configurations/rules/getRule'
import { getHistoricalByRule } from '@/services/historical/getHistoricalByRule'
import { getHistoricalByRuleExcel } from '@/services/historical/getHistoricalByRuleExcel'

export default {
  name: 'list-rule-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 78,
      vuexnamespace: 'historicalRule',
      headerUrl: 'configurations/rules/details',
      breadcrumbs: [
        { 
          url: this.role === 3 ? 'configurationssa' : 'configurations', 
          name: i18n.t('configurations.header') 
        },
        { url: 'configurations/rules', name: i18n.t('rules.header') },
        { paths: ['Nombre'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('rules.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idRegla: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getRule(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByRuleExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByRule(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
